import React, { useMemo } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import BasePage from '@ts-core/pages/BasePage';
import { PricingMode } from '@ts-core/utils/Constants';

import CoursesPage from 'modules/courses/pages/CoursesPage';
import NewCoursePage from 'modules/courses/pages/NewCoursePage';
import EditCoursePage from 'modules/courses/pages/EditCoursePage';
import AcademyPage from 'modules/academies/pages/academy/AcademyPage';

import AcademyBillingLegacyPage from 'modules/billing-legacy/pages/AcademyBilledCoursesLegacyPage';
import CourseBillingLegacyPage from 'modules/billing-legacy/pages/CourseBillingLegacyPage';
import CourseDashboardPage from 'modules/courses/pages/CourseDashboardPage';

import PaymentsOverviewPage from 'modules/billing/pages/OverviewPage';
import CourseActivityByMonthPage from 'modules/billing/pages/CourseActivityByMonthPage';
import StudentActivityByMonthPage from 'modules/billing/pages/StudentActivityByMonthPage';

import ProfessorNavigationBarContainer from 'core/components/ProfessorNavigationBarContainer';

import ProfessorProfilePage from 'modules/auth/pages/ProfessorProfilePage';
import { useProfessorAuth } from 'modules/auth/hooks';

const ProfessorPrivateSection = () => {
  const { user, isAuthenticated } = useProfessorAuth();
  const academy = user?.academy;

  const billingRoutes = useMemo(() => {
    if (
      academy?.pricing?.mode !== PricingMode.StudentPeriod &&
      academy?.pricing?.mode !== PricingMode.StudentCourseMonth &&
      academy?.pricing?.mode !== PricingMode.StudentMonth
    )
      return [];

    var routes = [];

    if (academy?.pricing?.mode === PricingMode.StudentCourseMonth) {
      routes.push(
        {
          path: '/billing-legacy/courses/:courseId/:invoiceId?',
          component: CourseBillingLegacyPage,
        },
        {
          path: '/billing-legacy',
          component: AcademyBillingLegacyPage,
        }
      );
    }

    return [
      ...routes,
      { component: StudentActivityByMonthPage, path: '/billing/:year/:month/:courseId/:studentId/:activityType', exact: true },
      {
        path: '/billing/:year/:month/:courseId',
        component: CourseActivityByMonthPage,
        exact: true,
      },
      {
        path: '/billing',
        component: PaymentsOverviewPage,
      },
    ];
  }, [academy]);

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  if (user?.mustChangePassword && user.resetPasswordToken) {
    return <Redirect to={`/set-new-password?token=${user.resetPasswordToken}`} />;
  }

  return (
    <>
      <ProfessorNavigationBarContainer />
      <BasePage>
        <Switch>
          <Route path="/courses/new" exact component={NewCoursePage} />
          <Route path="/courses/:courseId/edit" exact component={EditCoursePage} />
          <Route path="/courses" exact component={CoursesPage} />
          <Route path="/academy" exact component={AcademyPage} />
          <Route path="/profile" exact component={ProfessorProfilePage} />
          {billingRoutes.map((route, index) => (
            <Route key={`billing-${index}`} path={route.path} component={route.component} exact={route.exact} />
          ))}
          <Route path="/:courseId" component={CourseDashboardPage} />
        </Switch>
      </BasePage>
    </>
  );
};

export default ProfessorPrivateSection;
